module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5620G"))).then(() => parcelRequire('zWg3W'));